import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="shell grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">FAQ</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            关于瓜料来源、更新频率与投稿方式，这里一次说清楚。还有疑问可以在页面底部把问题写给我们。
          </p>
          <a href="#contact" className="btn-ghost mt-6">
            <i className="ri-question-line" aria-hidden="true" />
            没找到答案？提问
          </a>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">{faq.q}</span>
                    <i
                      className={`ri-add-line shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                        isOpen ? "rotate-45" : "rotate-0"
                      }`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-100 px-5 py-4 text-sm leading-7 text-foreground-600">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}